import React from "react";
import "./hero.css";

const Hero = () => {
  return (
    <section className="herosection">
      <h1 className="heading">
        Digital Transformation Through <span className="gradient-text">IT Solutions</span>{" "}
      </h1>
      <p className="subheading">
        We aspire to create a world where technology enhances lives, turning
        this vision into reality.
      </p>
    </section>
  );
};

export default Hero;
